import {axiosInstance} from "@/plugins/axios";
import {BOMSubassemblyFilter, BOMWithSubassemblies} from "@/modules/bom_subassembly/types";

export async function getSubassemblyBoms(payload: BOMSubassemblyFilter) {
    let url = `boms_subassembly/${payload.id}`

    if (payload.limit) {
        url +=`?offset=${payload.offset}&limit=${payload.limit}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}

export async function saveBOMWithSubassemblies(BOMWithSubassemblyComponents: BOMWithSubassemblies) {
    await axiosInstance.post(`boms_subassembly/create_or_update_many`, {
        bomComponents: BOMWithSubassemblyComponents.bomComponents,
        updated_by: BOMWithSubassemblyComponents.updated_by
    });
}
